import { render, staticRenderFns } from "./allocateDetail.vue?vue&type=template&id=71d12dc0&scoped=true"
import script from "./allocateDetail.vue?vue&type=script&lang=js"
export * from "./allocateDetail.vue?vue&type=script&lang=js"
import style0 from "./allocateDetail.vue?vue&type=style&index=0&id=71d12dc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d12dc0",
  null
  
)

export default component.exports